import { createSelector } from '@reduxjs/toolkit';

import type { TSeoBreadcrumbItem } from '../../types/features/landing';
import type { IApplicationState } from '../../types/redux';

export const selectSeoBreadcrumbItems = createSelector(
  (state: IApplicationState) => state.landing.seoBreadcrumbs?.breadcrumbs,
  (items): TSeoBreadcrumbItem[] => {
    if (!items?.length) {
      return [];
    }

    return [...items].sort((a, b) => a.position - b.position);
  },
);
